import { Component, OnInit, ViewChild } from '@angular/core';
import { Message } from 'primeng/api/message';
import { AccountService } from '../../services/AccountService';
import { UserService } from '../../services/UserService';
import { NgForm } from '@angular/forms';
import { ValidateformComponent } from '../../common/validateform/validateform.component';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from '../../models/user';
import { ResourceService } from '../../services/ResourceService';
import { AlertService } from '../../services/AlertService';

@Component({
  selector: 'app-user-login',
  templateUrl: './user-login.component.html',
  styleUrls: ['./user-login.component.scss']
})
export class UserLoginComponent implements OnInit {

    @ViewChild('f', { static: true }) loginFormValidate: NgForm;
    @ViewChild('loginForm', { static: true }) private formValidator: ValidateformComponent;

    password: string = '';
    username: string = '';

    constructor(private accountService: AccountService,
                private userService: UserService,
                private router: Router,
        private resouceService: ResourceService,
        private alertService: AlertService,
        private activatedRoute: ActivatedRoute) {         
    }

    ngOnInit() {
        var user = this.accountService.userValue;
        if (user != null)
            this.router.navigate(['']);
    }

    Login() {
        if (this.formValidator.validateForm()) {
            var user = new User();
            user.password = this.password;
            user.username = this.username;

            this.userService.validateUser(user).subscribe(result => {
                localStorage.setItem("authToken", "Bearer " + result.access_token);          
                this.userService.GetUserByEmail(this.username).subscribe(result => {
                    user.broker = result;
                    const returnUrl = this.activatedRoute.snapshot.queryParams['returnUrl'] || '';

                    this.accountService.LogIn(user, returnUrl);
                    //this.alertService.SetMessage('success', 'Login successful!');
                },
                error => {
                    this.alertService.SetMessage('error', 'There is an error while getting user info.');
                });
            },
            error => {
                this.alertService.SetMessage('error', 'Invalid username or password, or user not authorized.');
            });
        }       
    }

    ShowPolicy(policyTypeId) {
        this.resouceService.GetPolicyUrlByDocTypeId(policyTypeId.toString()).subscribe(res => {
            var wnd = window.open("about:blank", "", "_blank");
            wnd.document.write(res.toString());
        },
        err => {
        })
        
    };
}
